import React, { lazy, Suspense } from 'react';

const LazyTaiXe = lazy(() => import('./TaiXe'));

const TaiXe = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode }) => (
  <Suspense fallback={null}>
    <LazyTaiXe {...props} />
  </Suspense>
);

export default TaiXe;
